import { render } from "./Draaiboek.vue?vue&type=template&id=76e6a56e"
import script from "./Draaiboek.vue?vue&type=script&lang=js"
export * from "./Draaiboek.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__